<template>
  <div class="section section-about-office pb-0">
    <div class="container">
      <div class="md-layout text-center">
        <div class="md-layout-item md-size-90 md-small-size-100 mx-auto">
          <h2 class="title">Un lugar para descansar</h2>
          <h3 class="description">
            Hotel Brisas de Lago, tu casa en Valle de Bravo, brinda a sus
            huéspedes un lugar de descanso, relajación. Hacen que su estadía sea
            una buena opción para un gran fin de semana.
          </h3>
        </div>
      </div>
    </div>
      
      <div class="md-layout-item md-small-size-100">
        <div class="md-layout">
        <div class="md-layout-item md-size-100 md-small-size-100 md-layout ">
          <el-carousel
            indicator-position="none"
            trigger="click"
            :interval="5000"
            class="imagen"
          >
            <el-carousel-item
              v-for="item in carousel"
              :key="item.image"
              class="imagen"
              alt="Image"
            >
              <img
                :src="item.image"
                alt="Raised Image"
                :style="styleObject.carruselgaleria"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
         
        <div class="md-layout-item md-size-50 md-small-size-100">
          <img
            class="img-raised rounded"
            alt="Raised Image"
            :src="aboutOffice.aboutOffice4"
          />
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <img
            class="img-raised rounded"
            alt="Raised Image"
            :src="aboutOffice.aboutOffice5"
          />
        </div>
        <div class="md-layout-item md-size-25 md-small-size-100">
          <img
            class="img-raised rounded"
            alt="Raised Image"
            :src="aboutOffice.aboutOffice1"
          />
        </div>
        <div class="md-layout-item md-size-25 md-small-size-100">
          <img
            class="img-raised rounded"
            alt="Raised Image"
            :src="aboutOffice.aboutOffice3"
          />
        </div>
        <div class="md-layout-item md-size-25 md-small-size-100">
          <img
            class="img-raised rounded"
            alt="Raised Image"
            :src="aboutOffice.aboutOffice2"
          />
        </div>
        <div class="md-layout-item md-size-25 md-small-size-100">
          <img
            class="img-raised rounded"
            alt="Raised Image"
            :src="aboutOffice.aboutOffice7"
          />
        </div>
      </div>
       </div>
       
  </div>
 
</template>

<script>
import Vue from "vue";
import { Carousel } from "element-ui";

export default {
  data() {
    Vue.use(Carousel);

    return {
      speciality: "",
      name: null,
      email: null,
      image: require("@/assets/img/bg9.jpg"),
      aboutTeam: {
        aboutTeam1: require("@/assets/img/faces/marc.jpg"),
        aboutTeam2: require("@/assets/img/faces/kendall.jpg"),
        aboutTeam3: require("@/assets/img/faces/christian.jpg"),
        aboutTeam4: require("@/assets/img/faces/avatar.jpg"),
      },
      aboutOffice: {
        aboutOffice1: require("@/assets/img/examples/office2.jpg"),
        aboutOffice2: require("@/assets/img/examples/office4.jpg"),
        aboutOffice6: require("@/assets/img/examples/brisas1.jpg"),
        aboutOffice3: require("@/assets/img/examples/office3.jpg"),
        aboutOffice4: require("@/assets/img/examples/office5.jpg"),
        aboutOffice5: require("@/assets/img/examples/office1.jpg"),
        aboutOffice7: require("@/assets/img/examples/office6.jpg"),
      },
      carousel: [
        {
          image: require("@/assets/img/examples/brisas3.jpg"),
          title: "Somewhere Beyond, United States",
        },
        {
          image: require("@/assets/img/examples/brisas2.jpg"),
          title: "Yellowstone National Park, United States",
        },
        {
          image: require("@/assets/img/examples/brisas1.jpg"),
          title: "National Park, United States",
        },
        {
          image: require("@/assets/img/examples/brisas5.jpg"),
          title: "National Park, United States",
        },
        {
          image: require("@/assets/img/examples/brisas6.jpg"),
          title: "National Park, United States",
        },
        {
          image: require("@/assets/img/examples/brisas7.jpg"),
          title: "National Park, United States",
        },
        {
          image: require("@/assets/img/examples/brisas8.jpg"),
          title: "National Park, United States",
        },
        {
          image: require("@/assets/img/examples/brisas4.jpg"),
          title: "National Park, United States",
        },
        
      ],
      styleObject: {
        carruselgaleria: {
          height: "100%",
          width: "100%",
        },
      },
    };
  },
};
</script>

<style>
.imagen {
  
  height: 500px !important;
  width: 1060px !important;
  border-radius: 0 !important;
  align-items: center;
  
}
   
</style>
